import { handleActions } from 'redux-actions'
import { selectorForSlice, setState } from 'lp-redux-utils'
import * as actions from './actions'

const reducerKey = 'seaTowAsAGift'
const slice = 'root.memberPortal.seaTowAsAGift'

const initialState = {}
const reducer = handleActions(
  {
    // Membership type selection
    [actions.setSelectedMembershipType]: setState('selectedMembershipType'),
    // Gift Recipient
    [actions.setGiftMessage]: setState('giftMessage'),
    [actions.setRecipientContact]: setState('recipientContact'),
    // Billing
    [actions.setBillingContact]: setState('billingContact'),
    // Confirmation
    [actions.clearAllGiftState]: () => initialState,
  },
  initialState
)

const select = selectorForSlice(slice)

const selectors = {
  billingContact: select('billingContact'),
  giftMessage: select('giftMessage'),
  invoice: select('invoice'),
  recipientContact: select('recipientContact'),
  recipientType: select('recipientType'),
  selectedMembershipType: select('selectedMembershipType'),
}

export { reducer, selectors, reducerKey }
